import DOMPurify from 'dompurify'
import { FC } from 'react'


const HTMLRenderer: FC<{ html: string }> = ({ html }) => {
    const cleanHtml = DOMPurify.sanitize(html)
    
    return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
}

export default HTMLRenderer
